import React from "react";
import JavaScript from "../assets/javascript.png";
import CSS from "../assets/css.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import Mongo from "../assets/mongo.png";
import Github from "../assets/github.png";
import Tailwind from "../assets/tailwind.png";
import html from "../assets/html.png";
import graphql from "../assets/graphql-icon.svg";
import gatsby from "../assets/gatsby-js-icon.svg";
import jest from "../assets/jest.png";
import mysql from "../assets/mysql.svg";

import nextjs from "../assets/nextjs.svg";
import typescript from "../assets/typescript.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Redux from "../assets/redux.svg";
import "react-lazy-load-image-component/src/effects/blur.css";
const Skills = () => {
  return (
    <section
      id="skill"
      name="skill"
      className="w-full pb-[100px] bg-[#0f172a] text-gray-300"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="inline text-4xl font-bold text-gray-300 border-b-4 border-violet-600">
            Skills
          </p>
          <p className="py-4">//These are the technologies I've worked with</p>
        </div>

        <div className="grid w-full grid-cols-2 gap-4 py-8 text-center sm:grid-cols-3">
          {/* <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={html}
              alt="Mongo icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">HTML</p>
          </div> */}
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={CSS}
              alt="HTML icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">CSS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={JavaScript}
              alt="Javascript icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">Javascript</p>
          </div>
          {/* <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={typescript}
              alt="Node icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">Typescript</p>
          </div> */}
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={ReactImg}
              alt="React icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">React</p>
          </div>
          {/* <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={Redux}
              alt="Github"
              className="w-20 mx-auto"
            />
            <p className="my-4">Redux</p>
          </div> */}
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={gatsby}
              alt="Node icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">GatsbyJS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={Tailwind}
              alt="React icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">Tailwind</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={nextjs}
              alt="Node icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">NextJS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={mysql}
              alt="Node icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">MySQL</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={Node}
              alt="Node icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">NodeJS</p>
          </div>
          {/* <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={Mongo}
              alt="Mongo icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">MongoDB</p>
          </div> */}

          {/* <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={graphql}
              alt="Node icon"
              className="w-20 mx-auto"
            />
            <p className="my-4">Graphql</p>
          </div> */}

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={Github}
              alt="Github"
              className="w-20 mx-auto"
            />
            <p className="my-4">Github</p>
          </div>
          {/* <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
            <LazyLoadImage
              height="136"
              width="312"
              src={jest}
              alt="Jest"
              className="w-20 mx-auto"
            />
            <p className="my-4">Jest</p>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Skills;
